module.exports = __webpack_public_path__ + "img/pdf.cb3bb066.svg";